import { clsx } from 'clsx'
import { type FC, type PropsWithChildren } from 'react'

import styles from './CmsSlider.module.css'

type CmsSliderItemProps = PropsWithChildren<{
  className?: string
}>

export const CmsSliderItem: FC<CmsSliderItemProps> = ({
  children,
  className,
}) => {
  return (
    <li className={clsx(styles['cms-slider__item'], className)}>{children}</li>
  )
}
